import React from "react";
import styles from './overviewSubPage.module.scss';
import defaultImage from '../../../assets/default.png';
import {Image} from '../../../components/CustomImage';
export default class OverView2 extends React.Component<any, any>{
    render() {
        const { pageDetails } = this.props;
        const images = pageDetails?.perspectiveImages || [];
        
        images.forEach(i => {
            i.elevationName = i?.imageName?.split('-')?.[2]?.split('[')?.[0]?.toLowerCase() || '';
            !i.elevationName?.includes('wall') && (i.elevationName = "3D View");
        });

        return (
            <React.Fragment>
                <div className={styles["page-over-container"]}>
                    <div className={styles["image-section-1"]}>
                    {
                            (images || []).map((image) => {
                                return (
                                    <div>
                                        <p className={styles["image-container-heading"]}>{image?.elevationName || "3D View"}</p>
                                        <Image crossOrigin="anonymous" className={styles["page-image"]} src={image?.imageUrl ? `${image?.imageUrl}?ver=${new Date().getTime()}` :defaultImage  } alt="" />
                                    </div>
                               )
                            })
                        }
                    </div>
                </div>
            </React.Fragment>

        )
    }

}